module.exports = __webpack_public_path__ + "assets/652ddaa3cd7370ba40ac396a7c5267d7.svg";